export default function PageHeader({ kicker, title, subtitle, actions, testid }) {
    return (
        <div
            className="flex flex-wrap items-end justify-between gap-5 mb-8"
            data-testid={testid}
        >
            <div className="min-w-0 max-w-3xl">
                {kicker && (
                    <div className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.18em] text-florefy-700 font-semibold mb-3">
                        <span className="h-1.5 w-1.5 rounded-full bg-florefy-500 shadow-[0_0_0_4px_rgba(79,138,67,0.1)]" />
                        <span>{kicker}</span>
                    </div>
                )}
                <h1 className="font-display text-[2rem] md:text-[2.5rem] leading-[1.08] font-bold tracking-[-0.04em] text-ink-900">
                    {title}
                </h1>
                {subtitle && (
                    <p className="text-sm md:text-[15px] leading-relaxed text-ink-500 mt-2.5 max-w-2xl">{subtitle}</p>
                )}
            </div>
            {actions && <div className="flex flex-wrap gap-2.5 shrink-0">{actions}</div>}
        </div>
    );
}
